import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface ProjectChannelRow {
  project_id: string;
  project_code: string | null;
  name: string;
  project_phase: string | null;
  last_activity_at: string | null;
  member_ids: string[];
}

/**
 * Prosjektkanalene til innlogget bruker i Chat-rommet (VIB-3024): aktive og
 * kommende prosjekter der brukeren er produksjonsleder, eier, tildelt, har
 * skrevet eller er nevnt. RPC-en `my_project_channels` svarer alltid for den
 * ekte sesjonen; `userId` er med i nøkkelen så cachen følger innloggingen.
 *
 * `["project-channels"]` er registrert i CACHE_REGISTRY under
 * project_comments, projects, project_owners og budget_line_assignments.
 */
export function useProjectChannels(userId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ["project-channels", userId],
    enabled: enabled && !!userId,
    queryFn: async (): Promise<ProjectChannelRow[]> => {
      const { data, error } = await supabase.rpc("my_project_channels");
      if (error) throw error;
      return ((data ?? []) as ProjectChannelRow[]).map((r) => ({ ...r, member_ids: r.member_ids ?? [] }));
    },
    staleTime: 60 * 1000,
  });
}
